// extracted by mini-css-extract-plugin
module.exports = {"BasicTips":"styleVerticalLayout_BasicTips__bZMrs","AdvancedTips":"styleVerticalLayout_AdvancedTips__9woSk"};